import React from "react"
import Card from "@mui/material/Card"
import CardContent from "@mui/material/CardContent"
import Typography from "@mui/material/Typography"
import {CardActionArea} from "@mui/material"
import Box from "@mui/material/Box"
import {useLanguage} from "../context/LanguageContext"

export default function MealDataCards({items}) {
  const {language} = useLanguage()

  return (
    <div>
      {items.map((item) => {

        const localizedProduct = item.productlanguage.find(
          (lang) => lang.language__code === language
        )

        const fallbackProduct = item.productlanguage[0]
        const productName =
          localizedProduct && localizedProduct.name
            ? localizedProduct.name
            : fallbackProduct.name
        const productDescription =
          localizedProduct && localizedProduct.description
            ? localizedProduct.description
            : fallbackProduct.description || ""

        const prices = item.productprice.map((price) => {
          //   console.log("Price Object:", price)

          return {
            unit: price.unit__name,
            unitId: price.unit,
            price: parseFloat(price.price).toFixed(2),
          }
        })

        return (
          <Card
            key={item.id}
            sx={{
              maxWidth: 345,
              marginBottom: 2,
              position: "relative",
              backgroundImage: `url('${item.image}')`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              height: 300,
            }}
          >
            <CardActionArea
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-end",
                position: "relative",
              }}
            >
              <Box
                sx={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  top: 0,
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  zIndex: 1,
                }}
              />
              <CardContent
                sx={{
                  position: "relative",
                  padding: 2,
                  zIndex: 2,
                  color: "white",
                }}
              >
                <Typography gutterBottom variant="h5" component="div">
                  {productName}
                </Typography>
                <Typography variant="body2" mb={2}>
                  {productDescription}
                </Typography>
                {prices.map((price, index) => (
                  <Typography variant="body2" key={index}>
                    {price.unit !== "Default" && `${price.unit}: `}
                    {price.price} TL
                  </Typography>
                ))}
              </CardContent>
            </CardActionArea>
          </Card>
        )
      })}
    </div>
  )
}
